<template>
	<!-- 我的收藏 弹窗开始 -->
	<div class="explain" id="myCollection">
	  <div class="rightWap">
	    <div class="myTracks">
	      <h1>我的收藏<img src="/images/rightClose.png" class="closePop" @click="closeFloat"/></h1>
	      <div class="total">          
	        <p>全部 <span>{{totalResultCount}}</span> 条收藏文章</p>          
	      </div>
	      <ul class="collection">
	        <li v-for="(item,index) in resultDataList">
						<template v-if="item.articletype==5">
							<router-link :to="{ name: 'yuntu', params: { column: item.labelid }}" target="_blank">
								{{item.title}}<img src="/images/arw_bule.png"/></router-link>
							<el-popconfirm @confirm="removefavo(item.id)" title="确定要删除此条收藏吗？">
							  <img slot="reference" src="/images/flow.png" class="unflow"/>
							</el-popconfirm>
						</template>
	          <template v-else>
	          	<router-link :to="{ name: 'detail', params: { id: item.articleid }}" target="_blank">
	          		{{item.title}}<img src="/images/arw_bule.png"/></router-link>
	          	<el-popconfirm @confirm="removefavo(item.id)" title="确定要删除此条收藏吗？">
	          	  <img slot="reference" src="/images/flow.png" class="unflow"/>
	          	</el-popconfirm>
	          </template>
	          <!-- <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div> -->
	        </li>
	        <!-- <li>
	          <a href="##">新版国家职业分类大典新增职业聚焦数字与绿色<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">用知识产权为数字经济插上“翅膀”<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">未来我国如何深耕新基建<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">阿联酋“雪中送炭”，德国能源危机稍缓<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">金壮龙：人工智能是数字经济发展的重点领域<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">我国牵头自动驾驶测试场景评价国际标准立项<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">网安园加速扩容，引入27家高精尖企业<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">挖数字经济潜能，为城市发展赋能<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">“卡位”数字经济转型ATM机何去何从<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li>
	        <li>
	          <a href="##">亚特兰大联储主席：美联储可实现2%通胀目标且避免严重损害经济<img src="images/arw_bule.png"/></a>
	          <img src="images/flow.png" class="unflow"/>
	          <div class="error" style="display: none">
	            <p>确定要删除此条收藏吗？</p>
	            <div>
	              <input type="button" value="取消" class="cancel"/>
	              <input type="button" value="确定" class="sub"/>
	            </div>
	          </div>
	        </li> -->
	      </ul>
	      <div class="pagediv">
	      	<el-pagination
	      				@size-change="changePageSize"
	      				@current-change="changeSearchPage"
	      				:current-page="pageNum"
	      				:page-sizes="[10, 15, 20]"
	      				:page-size="pageSize"
	      				layout="prev, pager, next"
	      				:total="totalResultCount">
	      			</el-pagination>
	      </div>
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.getFavoritefnc();
		},
		methods: {
			getFavoritefnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstFavorites',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							type:1,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.tempResult.artLst;
						_this.totalResultCount = response.data.data.data.tempResult.totalCount;
						_this.loadingMask = false;
						_this.$emit('senddata',_this.totalResultCount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			removefavo: function(id) {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/DelFavorites',
						responseType: 'json',
						params: {
							id: id,
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','删除收藏'],
								['pageid',_this.articleid]
							]);
							_this.changeSearchPage(1);
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getFavoritefnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.getFavoritefnc();
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
		},
	}
</script>

<style>
</style>
